export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CookeModalBtn.vue?vue&type=template&id=0b624695&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/banner/components/CookeModalBtn.vue?vue&type=template&id=0b624695&
// module id = 1215
// module chunks = 0